import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getApiRequest } from "../../services/getApiRequest";
import { END_POINTS } from "../../Helper/Constant";
import { hideLoader, showLoader } from "../loader/loaderSlice";

export const fetchProducts = createAsyncThunk(
  "products/fetchProducts",
  async (
    {
      page = 1,
      limit = 20,
      categoryId = "",
      categoryName = "",
      userId = "",
      country="",
      search = "",
    },
    { dispatch, rejectWithValue }
  ) => {
    dispatch(showLoader());
    try {
      const url = `${END_POINTS.GET_PRODUCTS}?page=${page}&limit=${limit}&userId=${userId}&category=${categoryName}&categoryId=${categoryId}&country=${country}&search=${encodeURIComponent(search)}`;

      const res = await getApiRequest(url);

      if (res?.success) {
        return {
          ...res.data,
          categoryId,
          categoryName,
        };
      } else {
        return rejectWithValue(res?.message || "Failed to fetch products");
      }
    } catch (error) {
      return rejectWithValue(error.message);
    } finally {
      dispatch(hideLoader());
    }
  }
);


const productSlice = createSlice({
  name: "products",
  initialState: {
    products: [],
    totalCount: 0,
    totalPage: 0,
    currentPage: 1,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload.products || [];
        state.totalCount = action.payload.total_count || 0;
        state.totalPage = action.payload.total_page || 0;
        state.currentPage = action.payload.current_page || 1;
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default productSlice.reducer;
